import { useEffect, useState } from "react";
import { Route, Switch, useLocation } from "wouter";
import { auth, type AuthUser } from "./api.js";
import { Shell } from "./components/Shell.js";
import { LoginPage } from "./pages/LoginPage.js";
import { Landing } from "./pages/Landing.js";
import { QueuePage } from "./pages/QueuePage.js";
import { Layer4Page } from "./pages/Layer4Page.js";
import { SharePage } from "./pages/SharePage.js";
import { AuditPage } from "./pages/AuditPage.js";
import { PipelineMonitor } from "./pages/PipelineMonitor.js";
import { LaporanPage } from "./pages/LaporanPage.js";

export function App() {
  const [user, setUser] = useState<AuthUser | null>(auth.getUser());
  const [, setLocation] = useLocation();

  useEffect(() => {
    const onStorage = () => setUser(auth.getUser());
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  // Public share route — no auth.
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/report")) {
    return <SharePage />;
  }

  if (typeof window !== "undefined" && window.location.pathname.startsWith("/laporan")) {
    return <LaporanPage />;
  }

  if (!user) {
    return (
      <Switch>
        <Route path="/" component={Landing} />
        <Route path="/login" component={LoginPage} />
        <Route>
          {() => {
            setLocation("/");
            return null;
          }}
        </Route>
      </Switch>
    );
  }

  return (
    <Shell user={user}>
      <Switch>
        <Route path="/">{() => <QueuePage user={user} />}</Route>
        <Route path="/klien/:id">{() => <Layer4Page user={user} />}</Route>
        <Route path="/audit">{() => <AuditPage user={user} />}</Route>
        <Route path="/pipeline-monitor">
          {() =>
            user.role === "owner" || user.role === "super_admin" ? (
              <PipelineMonitor user={user} />
            ) : (
              <div className="card text-center text-slate-500">Halaman ini hanya untuk owner / super admin.</div>
            )
          }
        </Route>
        <Route>
          <div className="card text-center text-slate-500">404 — Page not found</div>
        </Route>
      </Switch>
    </Shell>
  );
}
